module.exports = __webpack_public_path__ + "static/media/logo-branca-sombra.a37bd12b.png";